import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "./useAuth";
import { useDependencies } from "./useDependencies";
import { AcceptanceCheckbox } from "src/contexts/documentationArea/domain/AcceptanceCheckbox";
import { useDocumentationArea } from "./useDocumentationArea";
import { DocumentationAreaNotFoundError } from "src/contexts/documentationArea/domain/errors/DocumentationAreaNotFoundError";

export const useCreateSignedAcceptances = () => {
  const queryClient = useQueryClient();
  const { token } = useAuth();
  const { documentationArea, actor } = useDocumentationArea();
  const { documentationAreaController } = useDependencies();

  if (!documentationArea) {
    throw new DocumentationAreaNotFoundError();
  }

  const mutationFn = async (signedAcceptanceCheckboxes: AcceptanceCheckbox[]) => {
    return await documentationAreaController.createSignedAcceptances(
      token,
      documentationArea.getId(),
      actor!.getId(),
      signedAcceptanceCheckboxes,
    );
  };

  const { mutate, isPending, isError, isSuccess } = useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["getSignedAcceptance"] });
    },
  });

  return {
    createSignedAcceptances: mutate,
    createSignedAcceptancesError: isError,
    createSignedAcceptancesSuccess: isSuccess,
    createSignedAcceptancesPending: isPending,
  };
};
